import React, {Fragment} from "react";
import {Col, FormGroup, ModalBody, ModalFooter, Row} from "reactstrap";
import {FiMinus, FiPlus} from "react-icons/fi";
import AsteriskIcon from "../../../components/asteriskIcon";
import ZeusButton from "../../../components/Button";
import InputCreator from "../../../components/Forms/components/InputCreator";
import ToggleCreator from "../../../components/Forms/components/ToggleCreator";
import {useFormData} from "./useFormData";

const CustomFieldChoicesForm = (props) => {
  const {data, onCancel} = props;
  const {
    addChoice,
    formData,
    handleChange,
    handleChoiceChange,
    handleSubmit,
    removeChoice,
  } = useFormData(data, onCancel);
  const {
    description = "",
    extra_choices = [{label: "", value: ""}],
    name = "",
    order_alphabetically = false,
  } = formData;

  return (
    <Fragment>
      <ModalBody>
        <Row>
          <InputCreator
            data-cy="name"
            inSingleRow
            isRequired
            label="Name"
            large
            name="name"
            value={name}
            onChange={handleChange}
          />
          <InputCreator
            data-cy="description"
            inSingleRow
            label="Description"
            large
            name="description"
            value={description}
            onChange={handleChange}
          />
          <ChoicesField
            addChoice={addChoice}
            choices={extra_choices}
            handleChoiceChange={handleChoiceChange}
            removeChoice={removeChoice}
          />
          <div data-cy="order-alphabetically">
            <ToggleCreator
              inSingleRow
              label="Order Alphabetically"
              large={true}
              name="order_alphabetically"
              checked={order_alphabetically}
              onChange={() =>
                handleChange({
                  target: {name: "order_alphabetically", value: !order_alphabetically},
                })
              }
            />
          </div>
        </Row>
      </ModalBody>
      <ModalFooter>
        <ZeusButton data-cy="submit-btn" onClick={handleSubmit}>
          SAVE
        </ZeusButton>
        <ZeusButton data-cy="cancel-btn" onClick={onCancel} className="info-small">
          CANCEL
        </ZeusButton>
      </ModalFooter>
    </Fragment>
  );
};

export default CustomFieldChoicesForm;

const ChoicesField = (props) => {
  const {addChoice, choices, handleChoiceChange, removeChoice} = props;
  return (
    <Col xs="12">
      <FormGroup row>
        <Col md="3">
          <label className="form-control-label roboto-bold" htmlFor="choices">
            Choices
          </label>
          <AsteriskIcon />
        </Col>
        <Col md="9">
          <div className="d-flex flex-column mb-2">
            {choices.map((choice, index) => (
              <Row key={index}>
                <InputCreator
                  colSize={4}
                  data-cy={`choice-label`}
                  placeholder="Label"
                  name={`choice-label-${index}`}
                  value={choice.label}
                  onChange={(e) => handleChoiceChange(index, "label", e.target.value)}
                />
                <InputCreator
                  colSize={6}
                  data-cy={"choice-value"}
                  placeholder="Value"
                  name={`choice-value-${index}`}
                  value={choice.value}
                  onChange={(e) => handleChoiceChange(index, "value", e.target.value)}
                />
                <Col md={1}>
                  <ZeusButton
                    classes="d-flex align-items-center justify-content-center"
                    data-cy={"remove-choice-btn"}
                    type="secondary"
                    onClick={() => removeChoice(index)}
                    title="Remove choice"
                    style={{
                      width: 36,
                      height: 42,
                      padding: 8,
                      minWidth: 36,
                    }}
                  >
                    <FiMinus size={16} />
                  </ZeusButton>
                </Col>
              </Row>
            ))}
            <div className="d-flex justify-content-end mr--2">
              <ZeusButton
                classes="d-flex align-items-center justify-content-center font-weight-normal"
                data-cy="add-choice-btn"
                type="secondary"
                onClick={addChoice}
              >
                <FiPlus size={16} />
                <span>Add Choice</span>
              </ZeusButton>
            </div>
          </div>
        </Col>
      </FormGroup>
    </Col>
  );
};
